<div
    class="flex"
    [ngClass]="
        direction() === 'vertical'
            ? 'flex-row gap-3 items-start'
            : 'flex-col gap-2'
    "
>
    @if (label(); as label) {
        <app-label [required]="required()">{{ label }}</app-label>
    }
    <div
        class="flex gap-4 text-sm"
        [ngClass]="itemDirection() === 'vertical' ? 'flex-col' : 'flex-row'"
    >
        @for (option of options(); track $index) {
            <app-radio-option
                (click)="select(option.value)"
                [active]="value() === option.value"
                [label]="option.label"
                [description]="option.description"
                [disabled]="option.disabled!"
            />
        }
    </div>
</div>
